import React from 'react'

import { faker } from '@faker-js/faker/locale/en'
import Link from 'next/link'

import * as S from './styles'
import { useServicesSection } from './useServicesSection'
import { Button } from '../../components/button'
import { Text } from '../../components/text'
import { Service } from '@/service/api/home'

type ServicesContainerProps = {
  /**
   * Data of services container
   *
   * @example
   * ```tsx
   * const data = {
   * ...
   * }
   *
   * <ServicesContainer servicesData={data} />
   * ```
   */
  servicesData: Service
}

export const ServicesContainer: React.FC<ServicesContainerProps> = ({
  servicesData,
}) => {
  const { fontSizes } = useServicesSection()

  if (!servicesData.title) return null
  return (
    <S.ServicesContainer>
      <S.DescriptionContainer>
        <Text size={fontSizes.title} color="primary">
          {servicesData.title}
        </Text>
        <Text size="b3" lineHeight="b2" className="description">
          {servicesData.description}
        </Text>
        <div className="button-container">
          <Link href="/services" passHref>
            <Button width={100}>{servicesData.buttonText}</Button>
          </Link>
        </div>
      </S.DescriptionContainer>
      <S.ServiceListingContainer>
        {servicesData.ourServices.map((service) => (
          <S.DescribedServiceContainer key={faker.datatype.uuid()}>
            <Text size={fontSizes.topicTitle} color="primary">
              {service.title}
            </Text>
            <Text size={fontSizes.topicDescription}>{service.description}</Text>
          </S.DescribedServiceContainer>
        ))}
      </S.ServiceListingContainer>
    </S.ServicesContainer>
  )
}
